import { ApplicationSettingsOutlineIcon } from './ApplicationSettingsOutlineIcon';

/**
 * author: CoreyVidal
 * id EB7E0628-A5CC-4E23-9AD1-CC35CC4E3722
 * name application-settings-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-settings-outline.svg
 * tags
 * - Settings 
 */
export const IframeSettingsOutlineIcon = ApplicationSettingsOutlineIcon;
export default IframeSettingsOutlineIcon